import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledHeader = styled.h2`
  text-align: left;
  color: ${({ theme }) => theme.color.first};
  font-size: ${({ theme }) => theme.font.size.s};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  font-family: Raleway, sans-serif;
  line-height: 32px;
  margin: 15px 0;
  position: relative;
  &::before {
    content: '';
    width: 40px;
    height: 10px;
    background-color: ${({ theme }) => theme.color.fourth};
    position: absolute;
    top: 32px;
    left: 0;
  }
  ${({ theme }) => theme.mq.tablet} {
    font-size: ${({ theme }) => theme.font.size.sm};
    line-height: 50px;
    &::before {
      width: 100px;
      top: 50px;
    }
  }
  ${({ theme }) => theme.mq.desktop} {
    font-size: ${({ theme }) => theme.font.size.m};
    line-height: 75px;
    &::before {
      width: 60px;
      top: 70px;
    }
  }
  ${({ theme }) => theme.mq.big} {
    font-size: ${({ theme }) => theme.font.size.sm};
  }
`;

const HeaderFooter = React.forwardRef(({ children }, ref) => {
  return <StyledHeader ref={ref}>{children}</StyledHeader>;
});

HeaderFooter.displayName = 'HeaderFooter';

HeaderFooter.propTypes = {
  children: PropTypes.string.isRequired,
};

export default HeaderFooter;
